import { useState, useCallback } from 'react'
import { ValidationErrors } from '../types'
import {
  validateName,
  validateEmail,
  validateWebsite,
  validateTelephone,
  validateStatementDescriptor,
  validateAllFields,
  hasValidationErrors,
} from '../utils'

export const useFormValidation = () => {
  const [errors, setErrors] = useState<ValidationErrors>({
    name: '',
    email: '',
    website: '',
    telephone: '',
    statementDescriptor: '',
  })

  const validateField = useCallback(
    (field: keyof ValidationErrors, value: string) => {
      let error = ''

      switch (field) {
        case 'name':
          error = validateName(value)
          break
        case 'email':
          error = validateEmail(value)
          break
        case 'website':
          error = validateWebsite(value)
          break
        case 'telephone':
          error = validateTelephone(value)
          break
        case 'statementDescriptor':
          error = validateStatementDescriptor(value)
          break
      }

      setErrors((prev) => ({
        ...prev,
        [field]: error,
      }))

      return error
    },
    [],
  )

  const validateAllFormFields = useCallback(
    (formData: {
      name: string
      email: string
      website: string
      telephone: string
      statementDescriptor: string
    }) => {
      const validationErrors = validateAllFields(formData)
      setErrors(validationErrors)
      return validationErrors
    },
    [],
  )

  const hasErrors = useCallback(() => {
    return hasValidationErrors(errors)
  }, [errors])

  const clearErrors = useCallback(() => {
    setErrors({
      name: '',
      email: '',
      website: '',
      telephone: '',
      statementDescriptor: '',
    })
  }, [])

  return {
    errors,
    validateField,
    validateAllFormFields,
    hasErrors,
    clearErrors,
  }
}
